module.exports = __webpack_public_path__ + "img/iti-logo-plain.2eb81ce1.svg";